import { render, staticRenderFns } from "./Toppersonbubblepinnedentity.vue?vue&type=template&id=6bba5c20"
import script from "./Toppersonbubblepinnedentity.vue?vue&type=script&lang=js"
export * from "./Toppersonbubblepinnedentity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports